module.exports = __webpack_public_path__ + "img/dsp02.e1519214.png";